import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectProfitData } from '../../../selectors/selectProfit';
import { IHowToEarnSchema } from '../../../repositories/price-estimator/entities/how_to_earn/HowToEarnSchema';
import { IProfitItemLayout } from '../../../components/ProfitItem';
import { HelpByCian } from '../../../components/HelpByCian';
import { useIsDesktop } from '@cian/valuation-utils-component';
import {
  trackAgentFormClick,
  trackButtonClick,
  trackCloseHelpModal,
  trackDetailsClick,
  trackNewOfferClick,
  trackShowHelpModal,
} from '../utils/tracking';

export const useRentProps = (): IProfitItemLayout | null => {
  const isDesktop = useIsDesktop();

  const [isDetailsShow, setIsDetailsShow] = React.useState(false);
  const [isRentByCianOpen, setOpen] = React.useState(false);

  const profitData = useSelector(selectProfitData) as IHowToEarnSchema;
  const { rent } = profitData;

  const detailsItems: IProfitItemLayout['detailsItems'] = [];

  if (rent?.monthlyIncome) {
    detailsItems.push({
      title: 'Доход в месяц',
      value: rent.monthlyIncome,
    });
  }

  if (rent?.estimationPrice) {
    detailsItems.push({
      title: 'Оценка стоимости',
      value: rent.estimationPrice,
    });
  }

  const rentByCianOpenHandler = React.useCallback(() => {
    setOpen(true);
    trackButtonClick('goRent');
  }, []);
  const rentByCianCloseHandler = React.useCallback(() => {
    trackCloseHelpModal('CloseRentWCianPopup');
    setOpen(false);
  }, []);

  const openAgentForm = React.useCallback(() => {
    trackAgentFormClick('RentWAgentPopup');
    window.open('https://www.cian.ru/pik-arenda', '_blank');
  }, []);
  const openNewOffer = React.useCallback(() => {
    trackNewOfferClick('RentMyselfPopup');
    window.open('https://www.cian.ru/new-offer/', '_blank');
  }, []);

  const handleClick = React.useCallback(() => {
    setIsDetailsShow(!isDetailsShow);
    trackDetailsClick('detailedRent');
  }, [isDetailsShow, setIsDetailsShow]);

  if (!rent) {
    return null;
  }

  return {
    isDesktop,
    title: 'Сдать в долгосрочную аренду',
    description: 'Сэкономьте время и получайте пассивный доход с минимальными рисками',
    wrapperDescription: 'Доход долгосрочной аренды',
    income: rent.income,
    percentForYear: rent.percentForYear,
    details: rent.details,
    detailsItems,
    additionalInfo: rent.additionalInfo,
    showDetails: isDetailsShow,
    onClick: handleClick,
    buttonText: 'Сдать квартиру с Циан',
    onButtonClick: rentByCianOpenHandler,
    modalComponent: (
      <HelpByCian
        isDesktop={isDesktop}
        isOpen={isRentByCianOpen}
        onClose={rentByCianCloseHandler}
        headingTitle="Сдать квратиру с Циан"
        agentTitle="Сдадим квартиру за вас"
        agentDescription="Подберём арендатора, подготовим и застрахуем квартиру — бесплатно"
        openAgentForm={openAgentForm}
        openNewOffer={openNewOffer}
        onModalShow={() => trackShowHelpModal('RentWCianPopup')}
      />
    ),
  };
};
